/**
 * 模块: KeywordTrendPivot Formatters
 * 职责: 关键词趋势透视表格式化工具函数
 * 限制: <280行
 */

/**
 * 格式化数值（千分位）
 */
export const formatNumber = (num: number | null | undefined): string => {
  if (num === null || num === undefined) return '-';
  return num.toLocaleString('en-US');
};

/**
 * 格式化百分比
 */
export const formatPercent = (num: number | null | undefined): string => {
  if (num === null || num === undefined) return '-';
  return `${num.toFixed(2)}%`;
};

